// removed by extract-text-webpack-plugin
module.exports = {"burger":"_387JN2Z","burger__hidden":"_2CZGxSY"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Burger/Burger.css
// module id = ./template/components/Burger/Burger.css
// module chunks = client.sitechrome